<template>
    <div class="app-box">
        <vue-scroll-snap @scroll="checkScroll">
            <div class="item" id="block1" ref="block1">
                <img src="/img/otc/old/fkp-1-1.jpg" class="imgs" />
            </div>
            <div class="item" id="block2" ref="block2">
                <div class="item-contents">
                    <img src="/img/otc/old/fkp-2-1.jpg" class="imgs" />
                </div>
                <div class="item-btn" @click="toggleContent('block2')">
                    <img src="/img/otc/old/fkp-2-btn-1.jpg" class="imgs" />
                </div>
                <div
                    class="item-content"
                    :class="{ 'item-content--expanded': expanded.block2 }"
                >
                    <div class="item-content__frame">
                        <img
                            src="/img/otc/old/fkp-2-content-1.jpg"
                            class="item-content__img"
                            alt=""
                        />
                        <div v-show="!expanded.block2" class="item-content__glass" aria-hidden="true" />
                        <div v-show="!expanded.block2" class="item-content__curl" aria-hidden="true" />
                        <button
                            v-show="!expanded.block2"
                            type="button"
                            class="item-content__btn"
                            @click="toggleContent('block2')"
                        >
                            点击查看详情
                        </button>
                    </div>
                </div>
                <div class="item-contents">
                    <img src="/img/otc/old/fkp-2-2.jpg" class="imgs" alt="" />
                </div>
            </div>
            <div class="item" id="block3" ref="block3">
                <div class="item-contents">
                    <img src="/img/otc/old/fkp-3-1.jpg" class="imgs" />
                </div>
                <div class="item-btn" @click="toggleContent('block3-1')">
                    <img src="/img/otc/old/fkp-3-btn-1.jpg" class="imgs" />
                </div>
                <div
                    class="item-content"
                    :class="{ 'item-content--expanded': expanded['block3-1'] }"
                >
                    <div class="item-content__frame">
                        <img
                            src="/img/otc/old/fkp-3-content-1.jpg"
                            class="item-content__img"
                            alt=""
                        />
                        <div v-show="!expanded['block3-1']" class="item-content__glass" aria-hidden="true" />
                        <div v-show="!expanded['block3-1']" class="item-content__curl" aria-hidden="true" />
                        <button
                            v-show="!expanded['block3-1']"
                            type="button"
                            class="item-content__btn"
                            @click="toggleContent('block3-1')"
                        >
                            点击查看详情
                        </button>
                    </div>
                </div>
                <div class="item-btn" @click="toggleContent('block3-2')">
                    <img src="/img/otc/old/fkp-3-btn-2.jpg" class="imgs" />
                </div>
                <div
                    class="item-content"
                    :class="{ 'item-content--expanded': expanded['block3-2'] }"
                >
                    <div class="item-content__frame">
                        <img
                            src="/img/otc/old/fkp-3-content-2.jpg"
                            class="item-content__img"
                            alt=""
                        />
                        <div v-show="!expanded['block3-2']" class="item-content__glass" aria-hidden="true" />
                        <div v-show="!expanded['block3-2']" class="item-content__curl" aria-hidden="true" />
                        <button
                            v-show="!expanded['block3-2']"
                            type="button"
                            class="item-content__btn"
                            @click="toggleContent('block3-2')"
                        >
                            点击查看详情
                        </button>
                    </div>
                </div>
            </div>
        </vue-scroll-snap>
        <div class="circle-box">
            <div class="">
                <div
                    v-for="i in slideCount"
                    :key="i"
                    :class="['circle', { actived: activeIndex === i - 1 }]"
                ></div>
            </div>
        </div>
        <img src="/img/otc/img-arrow-down.png" class="imgs_arrow" alt="" />
    </div>
</template>

<script setup>

import { ref, reactive } from 'vue'
import VueScrollSnap from "vue-scroll-snap";
const expanded = reactive({
    block2: false,
    'block3-1': false,
    'block3-2': false,
})

const toggleContent = (key) => {
    expanded[key] = !expanded[key]
}

const slideCount = 3
const activeIndex = ref(0)
const block1 = ref(null)
const block2 = ref(null)
const block3 = ref(null)

const blockRefs = [block1, block2, block3]

const checkScroll = (event) => {
    const top = event.target.scrollTop
    let idx = 0
    for (let i = 0; i < blockRefs.length; i++) {
        const block = blockRefs[i].value
        if (!block) continue
        if (top >= block.offsetTop - 8) {
            idx = i
        }
    }
    activeIndex.value = idx
}
</script>
<style lang="scss" scoped>
.app-box {
    width: 100vw;
    height: 100vh;
}

.item,
.item-btn,
.item-contents,
.item-content {
    margin: 0;
    padding: 0;
    margin-top: -2px;
}

.item-btn {
    cursor: pointer;
}

.imgs {
    width: 100vw;
    margin: 0;
    padding: 0;
    object-fit: contain;
    display: block;
}

/* —— item-content 收起：16:9 + 毛玻璃 + 左上角卷页三角 —— */
.item-content {
    margin: 0;
    padding: 0;
    background: #eceae6;
}

.item-content__frame {
    /* 折角区域；左上三角为清晰原图 */
    --curl-s: min(30vw, 120px);
    position: relative;
    width: 100vw;
    aspect-ratio: 16 / 9;
    overflow: hidden;
    background: #eceae6;
    transition: aspect-ratio 0.4s ease;
}

.item-content__img {
    display: block;
    width: 100%;
    height: auto;
    object-fit: contain;
    object-position: top center;
}

/* 毛玻璃：左上折角整块不遮罩，露出清晰原图 */
.item-content__glass {
    position: absolute;
    inset: 0;
    z-index: 1;
    background: rgba(0, 80, 148, 0.55);
    backdrop-filter: blur(18px) saturate(1.15);
    -webkit-backdrop-filter: blur(18px) saturate(1.15);
    clip-path: polygon(
        0 var(--curl-s),
        var(--curl-s) 0,
        100% 0,
        100% 100%,
        0 100%
    );
    pointer-events: none;
}

/*
 * 与红色参考图完全一致：右上尖角 + 左下 + 底边 62%
 * 折角容器贴在页面左上角，形状不镜像
 */
.item-content__curl {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    width: var(--curl-s);
    height: var(--curl-s);
    pointer-events: none;

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        background: linear-gradient(
            128deg,
            rgba(255, 255, 255, 0.12) 0%,
            rgba(255, 255, 255, 0.55) 32%,
            #ffffff 48%,
            #f0ece6 100%
        );
        clip-path: polygon(100% 0, 0 100%, 62% 100%);
        -webkit-mask-image: radial-gradient(
            ellipse 90% 85% at 0% 0%,
            transparent 0%,
            transparent 42%,
            #000 72%
        );
        mask-image: radial-gradient(
            ellipse 90% 85% at 0% 0%,
            transparent 0%,
            transparent 42%,
            #000 72%
        );
        filter: drop-shadow(4px 8px 16px rgba(0, 40, 80, 0.28))
            drop-shadow(2px 4px 10px rgba(0, 0, 0, 0.14));
    }
}

.item-content__btn {
    position: absolute;
    top: 66%;
    left: 50%;
    z-index: 3;
    transform: translate(-50%, -50%);
    padding: 14px 40px;
    border: 1px solid rgba(255, 255, 255, 0.55);
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.28);
    backdrop-filter: blur(14px) saturate(1.2);
    -webkit-backdrop-filter: blur(14px) saturate(1.2);
    color: #fff;
    font-size: 17px;
    font-weight: 500;
    line-height: 1.2;
    white-space: nowrap;
    text-shadow: 0 1px 2px rgba(0, 40, 80, 0.35);
    box-shadow:
        0 4px 16px rgba(0, 40, 80, 0.2),
        inset 0 1px 0 rgba(255, 255, 255, 0.45);
    cursor: pointer;
}

/* —— 展开：全宽原图 —— */
.item-content--expanded {
    background: transparent;

    .item-content__frame {
        width: 100vw;
        aspect-ratio: auto;
        height: auto;
        background: transparent;
    }

    .item-content__img {
        width: 100%;
        height: auto;
        object-fit: contain;
        object-position: top center;
    }

}

.pages {
    display: flex;
    height: 100vh;
    width: 100vw;
    align-items: center;
    justify-content: center;
    background-color: #fff;
}

.scroll-snap-container {
    height: 100vh;
    width: 100vw;
}

.circle-box {
    width: 18px;
    position: fixed;
    left: 20px;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    top: 0;

    .circle {
        width: 10px;
        height: 10px;
        background-color: #eee;
        border-radius: 5px;
        margin-bottom: 10px;
    }

    .actived {
        background-color: red;
    }
}

.imgs_arrow {
    width: 44px;
    height: 44px;
    position: fixed;
    bottom: 20px;
    left: calc((100vw - 44px) / 2);
    animation: bounce 2s ease-in-out infinite;
}

@keyframes bounce {

    0%,
    100% {
        transform: translateY(0);
    }

    25% {
        transform: translateY(-20px);
    }

    50% {
        transform: translateY(10px);
    }

    75% {
        transform: translateY(-5px);
    }
}
</style>
